import {
  CDN_ASSETS,
  DO_NOT_APPLY_REWARDS_KEY,
  VXB,
  getCurrentCorpAccount,
  getConfigTenant,
  getIsEMEligible,
  isCorpTenant,
  isVesperTenant,
  useShowPolicyBanner,
  checkIsFreeFdaEnabled,
} from "@capone/common/src";
import { useBusinessExperimentsById, useExperimentIsVariant } from "@capone/experiments";
import { Box, Button, Divider, Typography } from "@material-ui/core";
import clsx from "clsx";
import {
  ActionButton,
  ActionLink,
  ApprovalBanner,
  ApprovalReasonTextarea,
  ButtonWrap,
  CheckoutStepper,
  ContactInfoForm,
  CorpRewardsEarnBanner,
  CorporateTypography,
  FunnelType,
  IContactInfo,
  Icon,
  IconName,
  PolicyBanner,
  InformationalModal as TreesModal,
  TripPurposePanel,
  TripDescription,
  VoidWindowNotice,
  emailRegex,
  handleUpdateSelectedTravelersList,
  phoneRegex,
} from "halifax";
import { Location } from "history";
import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useSelector } from "react-redux";
import { RouteComponentProps } from "react-router";
import {
  ADD_CONTACT_INFO,
  AIR_SAVE_AND_CONTINUE_CLICKED,
  CallState,
  CorpSessionInfo,
  FlightBookType,
  ITravelerStepErrors,
  PRICE_DROP_VIEWED,
  PriceDropProtectionEnum,
  PriceDropViewedProperties,
  TripCategory,
  VIEWED_PRICE_DROP_DETAILS,
} from "redmond";
import {
  AGENT_FEE,
  PaymentCard,
  PriceBreakdown,
  PriceDropProtection,
  PriceDropFOCreditBanner,
} from "../..";
import { ClientContext } from "../../../../../App";
import { config } from "../../../../../api/config";
import { trackEvent } from "../../../../../api/v0/analytics/trackEvent";
import { fetchCustomerDetails } from "../../../../../api/v0/customer/fetchCustomerDetails";
import {
  AVAILABLE,
  CHECKOUT_REWARDS_EARN_BANNER_EXPERIMENT,
  CREDIT_OFFER_STACKING_V1,
  PASSPORT_ENHANCEMENT,
  SEATS_UX_OPTIMIZATION,
  SEAT_SELECTION,
  TRAVEL_CREDIT_HISTORY_EXPERIMENT,
  TRAVEL_WALLET_OFFER_EXPERIMENT,
  TREES_MODAL_EXPERIMENT,
  VOID_WINDOW_EXPERIMENT,
  getExperimentVariant,
  useExperiments,
} from "../../../../../context/experiments";
import {
  PATH_BOOK,
  PATH_BOOK_CONFIRMATION,
  PATH_HOME,
} from "../../../../../utils/urlPaths";
import { getRewardsAccounts } from "../../../../rewards/reducer/selectors";
import {
  FlightShopProgressBar,
  FlightShopSummaryPanel,
} from "../../../../shop/components";
import { MulticityFlightShopProgressBar } from "../../../../shop/components/MulticityFlightShopProgressBar";
import { MultipleAirlinesFareModal } from "../../../../shop/components/MultipleAirlinesFareModal";
import {
  IVirtualInterliningVariant,
  VirtualInterliningModal,
} from "../../../../shop/components/VirtualIinterliningModal";
import { AddOnCustomize } from "../../../../shop/components/addOnComponents";
import {
  FlightShopStep,
  MulticityFlightShopStep,
} from "../../../../shop/reducer";
import { CheckoutSteps } from "../../../reducer";
import { SEATING } from "../../../reducer/selectors/textConstants";
import { OptIn } from "../../AlertOptIn";
import { PassportAwarenessCard } from "../../PassportAwarenessCard/component";
import { SeatSelection } from "../../SeatSelection";
import { TravelOfferSelection } from "../../TravelOfferSelection";
import {
  BOOK_BUTTON_TEXT,
  CHECKOUT_PRICE_BREAKDOWN_HEADER,
  CONTACT_INFO_HELPER_TEXT,
  CONTACT_INFO_SUBTITLE,
  CONTACT_INFO_TITLE_NO_STEP,
  REQUIRED_DETAILS_TEXT,
  SEAT_SELECTION_TITLE,
  TRAVELER_INFO_TITLE,
  TREES_BOLDED_MODAL_CTA_TEXT,
  TREES_MODAL_CTA_TEXT,
  TREES_MODAL_HEADER,
  TREES_MODAL_SUBTITLE,
  TREES_MODAL_TITLE,
} from "../../capone/DesktopFlightBookWorkflow/textConstants";
import {
  BusinessLoyaltyProgramSection,
  type BusinessLoyaltyProgramSectionHandle,
} from "halifax";
import { FlightTravelerSelectDropdownForm } from "../FlightTravelerSelectDropdownForm";
import { CorpDesktopFlightBookWorkflowConnectorProps } from "./container";
import "./styles.scss";

export interface ICorpDesktopFlightBookWorkflowProps
  extends RouteComponentProps,
    CorpDesktopFlightBookWorkflowConnectorProps {}

export const CorpDesktopFlightBookWorkflow = ({
  setContactInfo,
  scheduleQuote,
  finalizedItinerary,
  history,
  selectedTrip,
  confirmationEmail,
  confirmationPhoneNumber,
  isConfirmAndBookReady,
  priceDifferenceAcknowledged,
  schedulePayment,
  currentSession,
  payments,
  ancillaries,
  priceDropProtection,
  isFareOptimizationCreditShopTime,
  priceDropViewedProperties,
  priceQuote,
  hasDifference,
  isTravelerStepComplete,
  setSelectedPaymentMethodId,
  setSelectedRewardsAccountReferenceId,
  setSelectedSeats,
  isWaitingPriceQuote,
  priceQuoteErrors,
  setQuote,
  flightShopProgress,
  setFlightShopProgress,
  flightBookType,
  fetchInitialCrossSellHotelAvailability,
  fetchTravelWalletCreditHistory,
  fetchApplicableTravelWalletItems,
  airports,
  policyLimit,
  corporateTravel,
  bookingProgressList,
  isCustomizePageMarketplaceEnabled,
  isFlightBookWithAncillariesEnabled,
  isFlightBookWithAncillariesActive,
  isOptionSelectionComplete,
  fetchAncillaryOfferCallState,
  fetchAncillaryOffer,
  getCheckoutStepNumber,
  tripCategory,
  hasActiveRefundableFare,
  resetFetchAncillaryOfferState,
  isVoidWindowEligible,
  isTravelWalletPaymentOnly,
  multicityFlightShopProgress,
  setMulticityFlightShopProgress,
  smsBeenSelected,
  appNotifBeenSelected,
  hasSelectedDisruption,
  setUserTcpaConsentPhoneNumber,
  disruptionOptInEnabled,
  nonFDAdisruptionOptInEnabled,
  isInternationalTrip,
  tripDetails,
  disruptionDelayThreshold,
  shopRequest,
  viewedTripSummaryProperties,
  setTripPurpose,
  setTripDescription,
  updateUserPassengersMultiple,
  selectedTravelersList,
  setUserSelectedTravelersList,
  largestValueAccount,
  calculatedEarn,
  fetchCorpUserPassengers,
  passengersValidErrors,
  userPassengerCallState,
  passengerValidationCallState,
  fdaProductVariant,
}: ICorpDesktopFlightBookWorkflowProps) => {
  const clientContext = useContext(ClientContext);
  const { sessionInfo, isAgentPortal, isAutoApprovalEnabled, policies } =
    clientContext;
  const businessLoyaltyRef = useRef<BusinessLoyaltyProgramSectionHandle>(null);

  const rewardsAccounts = useSelector(getRewardsAccounts);
  const freeFdaVariant = useBusinessExperimentsById("corp-free-fda")?.variant;
  const isFreeFdaExperimentEnabled =
    freeFdaVariant === "available" || freeFdaVariant === "available_phase2";
  const isFreeFdaActive = checkIsFreeFdaEnabled({
    isFreeFdaExperimentEnabled,
    productVariant: fdaProductVariant,
  });
  const accountForBanner = useMemo(() => {
    if (isCorpTenant(config.TENANT)) {
      const corpAccount = getCurrentCorpAccount(rewardsAccounts, sessionInfo);
      return corpAccount || largestValueAccount;
    }
    return largestValueAccount;
  }, [rewardsAccounts, sessionInfo, largestValueAccount]);
  const isEMEligible = getIsEMEligible(accountForBanner);

  // NFU user detection - NFU users don't have the app, so hide push notifications
  // but keep SMS notifications by using the updated alert opt-in UI
  const isNonFinancialUser =
    (sessionInfo as CorpSessionInfo)?.corporateInfo?.cap1Role === "NFU";
  const isVesper = isVesperTenant(getConfigTenant());

  const [saveButtonClicked, setSaveButtonClicked] = useState(false);
  const [showErrors, setShowErrors] = useState<ITravelerStepErrors>({
    phone: false,
    email: false,
    travelerSelect: false,
    corpPrimaryTraveler: false,
    passengersValidate: false,
  });

  const isSaveButtonDisabled =
    userPassengerCallState === CallState.InProcess ||
    passengerValidationCallState === CallState.InProcess;

  // TODO: remove this when we decide if using text message - https://hopchat.slack.com/archives/C01FX0M22MV/p1620146159000600
  const [contactInfo, setContact] = useState<IContactInfo | null>({
    phoneNumber: confirmationPhoneNumber || "",
    email: confirmationEmail || sessionInfo?.userInfo?.email || "",
  });
  const [customerDetailsLoading, setCustomerDetailsLoading] =
    useState<boolean>(true);
  const [disableEditTravelerInfo, setDisableEditTravelerInfo] = useState(false);

  const [treeModalOpen, setTreeModalOpen] = useState(false);

  const isFirstStepCompletedInCheckout = isTravelerStepComplete;

  const expState = useExperiments();

  const showPolicyBanner = useShowPolicyBanner(policies, "flight");

  useEffect(() => {
    fetchCorpUserPassengers();
  }, []);

  const seatSelectionGroup = getExperimentVariant(
    expState.experiments,
    SEAT_SELECTION
  );

  const treesModalExperiment = getExperimentVariant(
    expState.experiments,
    TREES_MODAL_EXPERIMENT
  );

  const [approvalRequestReason, setApprovalRequestReason] = useState<
    string | undefined
  >();

  const isTreesModalExperiment = useMemo(
    () => treesModalExperiment === AVAILABLE,
    [treesModalExperiment]
  );

  const travelWalletOffer = getExperimentVariant(
    expState.experiments,
    TRAVEL_WALLET_OFFER_EXPERIMENT
  );
  const isTravelWalletOfferExperiment = useMemo(
    () => travelWalletOffer === AVAILABLE,
    [travelWalletOffer]
  );

  const travelCreditHistoryExperiment = getExperimentVariant(
    expState.experiments,
    TRAVEL_CREDIT_HISTORY_EXPERIMENT
  );
  const isTravelCreditHistoryExperiment = useMemo(
    () => travelCreditHistoryExperiment === AVAILABLE,
    [travelCreditHistoryExperiment]
  );

  const passportEnhancementExperiment = getExperimentVariant(
    expState.experiments,
    PASSPORT_ENHANCEMENT
  );

  const isPassportEnhancementExperiment = useMemo(
    () => passportEnhancementExperiment === AVAILABLE,
    [passportEnhancementExperiment]
  );

  const creditAndOfferStackingExperimentV1 = getExperimentVariant(
    expState.experiments,
    CREDIT_OFFER_STACKING_V1
  );
  const isCreditAndOfferStackingExperimentV1 = useMemo(
    () => creditAndOfferStackingExperimentV1 === AVAILABLE,
    [creditAndOfferStackingExperimentV1]
  );

  const isSeatsUXOptimizationExperiment = useMemo(
    () =>
      getExperimentVariant(expState.experiments, SEATS_UX_OPTIMIZATION) ===
      AVAILABLE,
    [expState]
  );

  const isVoidWindowExperiment = useMemo(
    () =>
      getExperimentVariant(expState.experiments, VOID_WINDOW_EXPERIMENT) ===
      AVAILABLE,
    [expState]
  );

  const isTripPurposeXpEnabled = useExperimentIsVariant(
    "corp-trip-purpose",
    AVAILABLE
  );

  const isExpenseManagementExperiment = useExperimentIsVariant(
    "corp-expense-management",
    AVAILABLE
  );

  const isCheckoutRewardsEarnBannerExperiment = useExperimentIsVariant(
    CHECKOUT_REWARDS_EARN_BANNER_EXPERIMENT,
    AVAILABLE
  );

  const hideSmsOptIn = useExperimentIsVariant(
    "hide-disruption-sms-notifications",
    AVAILABLE
  );
  const hideAppNotificationOptIn = useExperimentIsVariant(
    "hide-disruption-app-notifications",
    AVAILABLE
  );

  // Virtual Interline Flights will offer only one type of fare the most basic is safe to only check the first index
  const isVITripSelected = tripDetails.fareDetails[0]?.slices.some((slice) =>
    slice.fareDetails.segments.some((segment) => segment.isSelfTransferLayover)
  );

  // Follows patterns established elsewhere, but the flag is not (yet) needed in this context.
  const [openVIVariantModal, setOpenVIVariantModal] = useState<
    IVirtualInterliningVariant | "reminder" | false
  >(false);

  // Follows patterns established elsewhere, but the flag is not (yet) needed in this context.
  const [openMultipleAirlinesFares, setOpenMultipleAirlinesFares] =
    useState(false);

  const isInPolicyCheckout = corporateTravel?.policyCompliance.isInPolicy ?? true;

  const isMulticity = useMemo(
    () => tripCategory === TripCategory.MULTI_CITY,
    [tripCategory]
  );

  /*
      note: the proper way to handle the filtering logic is by passing the feature flag to redux, but since we currently have
      a plan to refactor that pattern (e.g. https://hopper-jira.atlassian.net/browse/BF-874), a workaround is used here for now
    */

  const isSeatSelectionGroupEnabled =
    seatSelectionGroup === AVAILABLE ||
    (corporateTravel?.policyCompliance.isInPolicy && isAutoApprovalEnabled);

  const bookingProgressSteps = bookingProgressList.filter(
    (progress) => progress.name !== SEATING || isSeatSelectionGroupEnabled
  );

  const disruptionDelayThresholdStringInHours =
    disruptionDelayThreshold === 180 ? "3" : "2";

  const onBookFlight = () => {
    if (selectedTrip.tripId) {
      priceQuote &&
      currentSession &&
      payments &&
      ancillaries &&
      (!hasDifference || priceDifferenceAcknowledged)
        ? schedulePayment({
            session: currentSession,
            payments,
            ancillaries,
            agentFee: isAgentPortal ? AGENT_FEE : 0,
            approvalRequestReason,
          })
        : scheduleQuote({ agentFee: isAgentPortal ? AGENT_FEE : 0 });
    }
  };

  const isPDPEligible =
    priceDropProtection &&
    priceDropProtection.PriceDropProtection ===
      PriceDropProtectionEnum.IsEligible;

  useEffect(() => {
    if (!shopRequest && !isInPolicyCheckout && !tripDetails) {
      history.push(PATH_HOME);
    }
  }, [shopRequest, isInPolicyCheckout, tripDetails]);

  useEffect(() => {
    if (finalizedItinerary) {
      fetchInitialCrossSellHotelAvailability(finalizedItinerary, airports);
      history.push(PATH_BOOK_CONFIRMATION);
      if (isPDPEligible) {
        const properties: PriceDropViewedProperties = {
          ...priceDropViewedProperties,
          page: "flight_book",
        };
        trackEvent({
          eventName: PRICE_DROP_VIEWED,
          properties,
        });
      }
    }
  }, [finalizedItinerary]);

  useEffect(() => {
    if (priceQuoteErrors.length > 0) {
      setDisableEditTravelerInfo(false);
    }
  }, [priceQuoteErrors]);

  useEffect(() => {
    if (passengersValidErrors.length === 0) {
      setShowErrors((prev) => ({
        ...prev,
        passengersValidate: false,
      }));
    }
  }, [passengersValidErrors.length]);

  useEffect(() => {
    // note: this handles if on the booking error modals, the button gets PQ again but does not bring user to next step (such as LapInfantsUnsupported error)
    if (priceQuote && priceQuoteErrors.length === 0 && isTravelerStepComplete) {
      setDisableEditTravelerInfo(true);
    }
  }, [priceQuote, priceQuoteErrors]);

  useEffect(() => {
    if (
      !isMulticity &&
      isFlightBookWithAncillariesEnabled &&
      fetchAncillaryOfferCallState === CallState.NotCalled
    ) {
      fetchAncillaryOffer({
        preserveCfarId: hasActiveRefundableFare,
      });
    }
  }, [
    isFlightBookWithAncillariesEnabled,
    fetchAncillaryOfferCallState,
    hasActiveRefundableFare,
  ]);

  useEffect(() => {
    if (isMulticity) {
      // Multi-city tracks flight shop progress a little differently. Book is a step in itself.
      setMulticityFlightShopProgress(MulticityFlightShopStep.BookTrip);
    }
  }, []);

  useEffect(() => {
    isTravelWalletOfferExperiment && fetchApplicableTravelWalletItems();
    isTravelCreditHistoryExperiment && fetchTravelWalletCreditHistory();
    const getCustomerDetails = async () => {
      try {
        const details = await fetchCustomerDetails();
        setUserTcpaConsentPhoneNumber(details?.phoneNumber || "");
        setContact({
          email: "",
          ...contactInfo,
          phoneNumber: details?.phoneNumber || "",
        });
        setContactInfo(contactInfo?.email || "", details?.phoneNumber || "");
      } finally {
        setCustomerDetailsLoading(false);
      }
    };

    getCustomerDetails();

    // note: resolve any potential loop caused by flightShopStep (if it exists)
    if (isMulticity) {
      const prevMulticityFlightShopProgress:
        | MulticityFlightShopStep
        | undefined = (
        history.location as Location<{
          multicityFlightShopProgress: MulticityFlightShopStep;
        }>
      ).state?.multicityFlightShopProgress;
      if (
        isMulticity &&
        prevMulticityFlightShopProgress !== undefined &&
        multicityFlightShopProgress !== prevMulticityFlightShopProgress
      ) {
        setMulticityFlightShopProgress(prevMulticityFlightShopProgress);
      }
    } else {
      const prevFlightShopProgress: FlightShopStep | undefined = (
        history.location as Location<{ flightShopProgress: FlightShopStep }>
      ).state?.flightShopProgress;
      if (
        !isMulticity &&
        prevFlightShopProgress !== undefined &&
        flightShopProgress !== prevFlightShopProgress
      ) {
        setFlightShopProgress(prevFlightShopProgress);
      }
    }
  }, []);

  useEffect(
    () => () => {
      if (isFlightBookWithAncillariesActive) {
        resetFetchAncillaryOfferState({
          preserveCfarId: hasActiveRefundableFare,
        });
      }
    },
    [isFlightBookWithAncillariesActive, hasActiveRefundableFare]
  );

  const renderLogo = (
    <ButtonWrap
      className="logo"
      onClick={() => {
        history.push(PATH_HOME);
      }}
    >
      {clientContext.logo}
    </ButtonWrap>
  );

  const handleReasonChange = useCallback(
    (e: React.ChangeEvent<HTMLTextAreaElement>, isCharLimitError: boolean) => {
      setApprovalRequestReason(e.target.value);
      if (isCharLimitError) {
        trackEvent({
          eventName: "approval_reason_char_limit_error",
          properties: {
            funnel: "flights",
          },
        });
      }
    },
    []
  );

  return (
    <Box
      className={clsx(
        "desktop-flight-book-workflow-root",
        "home-screen-redesign"
      )}
    >
      <CheckoutStepper
        steps={bookingProgressSteps}
        headerCopy={BOOK_BUTTON_TEXT}
        subHeaderCopy={REQUIRED_DETAILS_TEXT}
        logo={renderLogo}
        className={clsx("b2b", "combined-step")}
      />
      {isCustomizePageMarketplaceEnabled && (
        <Box className="flight-book-progress-bar-wrapper">
          {!isMulticity && flightBookType === FlightBookType.DEFAULT && (
            <FlightShopProgressBar
              useCustomizeStep
              prevPath={PATH_BOOK}
              usePush
            />
          )}
          {isMulticity && <MulticityFlightShopProgressBar />}
        </Box>
      )}
      <PriceDropFOCreditBanner />
      <Box
        className={clsx("desktop-flight-book-workflow-container", {
          "with-progress-bar": isCustomizePageMarketplaceEnabled,
          redesigned: isVesper,
        })}
      >
        <Box className={clsx("checkout-template-column", "left")}>
          <Box
            className={clsx(
              "checkout-template-card-content-container",
              "flight"
            )}
          >
            <FlightShopSummaryPanel
              showViewDetailsSection
              prevPath={PATH_BOOK}
              disableChangeFlight={false}
              isSeatsUXOptimizationExperiment={isSeatsUXOptimizationExperiment}
              isVITripSelected={isVITripSelected}
              setOpenVIVariantModal={setOpenVIVariantModal}
              setOpenMultipleAirlinesFares={setOpenMultipleAirlinesFares}
            />
          </Box>

          {isTripPurposeXpEnabled && !isExpenseManagementExperiment && (
            <Box
              className={clsx(
                "checkout-template-card-content-container",
                "hotel"
              )}
            >
              <TripPurposePanel setTripPurpose={setTripPurpose} />
            </Box>
          )}

          {isInternationalTrip && isPassportEnhancementExperiment && (
            <Box className="checkout-template-card-content-container">
              <PassportAwarenessCard />
            </Box>
          )}

          {!isMulticity &&
            isTravelWalletOfferExperiment &&
            !isCreditAndOfferStackingExperimentV1 && <TravelOfferSelection />}

          <Box
            className={clsx(
              "checkout-template-card-content-container",
              "traveler"
            )}
          >
            <Box className={clsx("checkout-template-description")}>
              <Typography
                variant="h2"
                className={clsx("checkout-template-title")}
              >
                {TRAVELER_INFO_TITLE(
                  getCheckoutStepNumber(CheckoutSteps.ADD_TRAVELERS)
                )}
              </Typography>
            </Box>
            {!isVesper && <Divider className="traveler-info-container-divider" />}
            <FlightTravelerSelectDropdownForm
              disableEditTravelerInfo={disableEditTravelerInfo}
              selectedTravelers={selectedTravelersList}
              updateSelectedTravelersList={(traveler) =>
                handleUpdateSelectedTravelersList(
                  traveler,
                  selectedTravelersList,
                  setUserSelectedTravelersList
                )
              }
              removeSelectedTraveler={(traveler) =>
                setUserSelectedTravelersList(
                  selectedTravelersList.filter((t) => t.id !== traveler.id)
                )
              }
              showErrors={showErrors}
              setShowErrors={setShowErrors}
            />
            <ContactInfoForm
              disabled={disableEditTravelerInfo}
              title={CONTACT_INFO_TITLE_NO_STEP}
              subtitle={CONTACT_INFO_SUBTITLE}
              contactInfo={contactInfo}
              onContactInfoChange={(info: IContactInfo) => {
                setContact(info);
                setContactInfo(info.email, info.phoneNumber);
                if (
                  info.email &&
                  info.phoneNumber &&
                  emailRegex.test(info.email) &&
                  phoneRegex.test(info.phoneNumber)
                ) {
                  trackEvent({
                    eventName: ADD_CONTACT_INFO,
                    properties: {},
                  });
                }
              }}
              showErrors={showErrors}
              setShowErrors={setShowErrors}
              loading={customerDetailsLoading}
              disruptionOptInPresent={
                hasSelectedDisruption && disruptionOptInEnabled && !isFreeFdaActive
              }
            />
            <OptIn
              disabled={disableEditTravelerInfo}
              smsBeenSelected={smsBeenSelected}
              appNotifBeenSelected={appNotifBeenSelected}
              hasSelectedDisruption={hasSelectedDisruption}
              disruptionOptInEnabled={disruptionOptInEnabled && !isFreeFdaActive}
              nonFDAdisruptionOptInEnabled={nonFDAdisruptionOptInEnabled}
              disrutpionDelayThresholdStringInHours={
                disruptionDelayThresholdStringInHours
              }
              useUpdatedAlertOptIn={isNonFinancialUser}
              hideSmsOptIn={hideSmsOptIn}
              hideAppNotificationOptIn={hideAppNotificationOptIn}
            />
            <BusinessLoyaltyProgramSection
              ref={businessLoyaltyRef}
              tripDetails={tripDetails}
              sessionInfo={sessionInfo}
              disabled={disableEditTravelerInfo}
              trackEvent={trackEvent}
            />
            {!disableEditTravelerInfo && (
              <ActionButton
                className={clsx(
                  "traveler-select-workflow-button",
                  "traveler-step-cta"
                )}
                message="Save and continue"
                disabled={isSaveButtonDisabled}
                onClick={async () => {
                  if (isFirstStepCompletedInCheckout) {
                    const persistOk =
                      (await businessLoyaltyRef.current?.persistIfNeeded()) ??
                      true;
                    if (!persistOk) return;
                    trackEvent({
                      eventName: AIR_SAVE_AND_CONTINUE_CLICKED,
                      properties: {
                        has_form_errors: false,
                      },
                    });
                    updateUserPassengersMultiple(selectedTravelersList);
                    scheduleQuote({
                      agentFee: isAgentPortal ? AGENT_FEE : 0,
                      pollQuoteOnly: true,
                    });
                    setDisableEditTravelerInfo(true);
                    setShowErrors({
                      phone: false,
                      email: false,
                      travelerSelect: false,
                      corpPrimaryTraveler: false,
                      passengersValidate: false,
                    });
                  } else {
                    trackEvent({
                      eventName: AIR_SAVE_AND_CONTINUE_CLICKED,
                      properties: {
                        has_form_errors: true,
                        traveler_error: !isTravelerStepComplete,
                        email_error:
                          !contactInfo || !emailRegex.test(contactInfo.email),
                        phone_error:
                          !contactInfo ||
                          !phoneRegex.test(contactInfo.phoneNumber),
                      },
                    });
                    setShowErrors({
                      phone:
                        !contactInfo ||
                        !phoneRegex.test(contactInfo.phoneNumber),
                      email:
                        !contactInfo || !emailRegex.test(contactInfo.email),
                      travelerSelect: !isTravelerStepComplete,
                      corpPrimaryTraveler: selectedTravelersList.length === 0,
                      passengersValidate:
                        selectedTravelersList.length > 0 &&
                        passengersValidErrors.length > 0,
                    });
                    if (!saveButtonClicked) {
                      setSaveButtonClicked(true);
                    }
                  }
                }}
                defaultStyle="h4r-primary"
                dataTestId="save-travelers-button"
              />
            )}
            {disableEditTravelerInfo && (
              <ActionLink
                className={clsx("traveler-step-cta", "b2b")}
                content={
                  <Box className="edit-traveler-link">
                    <Typography variant="body1">
                      Edit traveler information
                    </Typography>
                    <Icon
                      aria-hidden
                      className="icon-end"
                      name={IconName.B2BEditPencil}
                      ariaLabel=""
                    />
                  </Box>
                }
                onClick={() => {
                  // reset the price quote since it will be called again
                  setQuote(null);
                  setDisableEditTravelerInfo(false);
                  setSelectedPaymentMethodId({
                    paymentMethodId: "",
                    accountId: undefined,
                    multiTicketType:
                      viewedTripSummaryProperties?.multi_ticket_type,
                  });
                  setSelectedRewardsAccountReferenceId(
                    DO_NOT_APPLY_REWARDS_KEY
                  );
                  setSelectedSeats([]);
                }}
              />
            )}
            {showErrors.passengersValidate && (
              <Box className={clsx("valid-passengers-error-container")}>
                <CorporateTypography
                  variant="body2"
                  className={clsx("valid-passengers-error")}
                >
                  {passengersValidErrors[0]?.message}
                </CorporateTypography>
              </Box>
            )}
            <Box className={clsx("contact-info-helper-container")}>
              <Typography
                variant="body2"
                className={clsx("contact-info-helper-text")}
              >
                {CONTACT_INFO_HELPER_TEXT}
              </Typography>
            </Box>
          </Box>
          {seatSelectionGroup === AVAILABLE &&
            (isInPolicyCheckout || isAutoApprovalEnabled) && (
              <SeatSelection
                title={SEAT_SELECTION_TITLE(
                  getCheckoutStepNumber(CheckoutSteps.SEATING)
                )}
                disabled={
                  !isFirstStepCompletedInCheckout ||
                  !disableEditTravelerInfo ||
                  // note: in the flight-book variant of https://app.launchdarkly.com/capital-one/test/features/c1-fintech-ancillary-marketplace/targeting, the seat map data is persisted while refetching a new price quote
                  (isWaitingPriceQuote && !isFlightBookWithAncillariesActive)
                }
              />
            )}
          {isFlightBookWithAncillariesActive && (
            <Box
              className={clsx(
                "checkout-template-card-content-container",
                "ancillary"
              )}
            >
              <AddOnCustomize disableCollapse useFlightCheckoutVariant />
            </Box>
          )}
          <Box
            className={clsx(
              "checkout-template-card-content-container",
              "credit"
            )}
          >
            <PaymentCard
              disabled={
                !isFirstStepCompletedInCheckout ||
                !disableEditTravelerInfo ||
                (isFlightBookWithAncillariesActive &&
                  !isOptionSelectionComplete) ||
                (!isCreditAndOfferStackingExperimentV1 &&
                  isTravelWalletPaymentOnly)
              }
              className={clsx({ "less-padding": isTreesModalExperiment })}
            />
            {isTreesModalExperiment && (
              <TreesModal
                image={CDN_ASSETS.capone.trees.confirmation}
                header={TREES_MODAL_HEADER}
                title={TREES_MODAL_TITLE}
                onClose={() => setTreeModalOpen(false)}
                subtitle={TREES_MODAL_SUBTITLE}
                icon={<Icon className="trees-icon" name={IconName.TreesIcon} />}
                openModal={treeModalOpen}
                setOpenModal={setTreeModalOpen}
                modalLinkCopy={TREES_MODAL_CTA_TEXT}
                modalButtonCopyStartIcon={
                  <Icon className="trees-icon" name={IconName.TreesIcon} />
                }
                boldedModalLinkCopy={TREES_BOLDED_MODAL_CTA_TEXT}
              />
            )}
          </Box>

          {isTripPurposeXpEnabled && isExpenseManagementExperiment && (
            <Box
              className={clsx(
                "checkout-template-card-content-container",
                "hotel"
              )}
            >
              <TripDescription
                setTripDescription={setTripDescription}
                isEMEligible={isEMEligible}
              />
            </Box>
          )}
        </Box>
        <Box className={clsx("checkout-template-column", "right")}>
          <Box className="checkout-template-column-right-wrapper">
            <Box
              className={clsx(
                "checkout-template-card-content-container",
                "pricing-breakdown"
              )}
            >
              {showPolicyBanner && (
                <PolicyBanner isInPolicy={isInPolicyCheckout} />
              )}
              <Box className="pricing-breakdown-header-container">
                <Typography className="header" variant="h2">
                  {CHECKOUT_PRICE_BREAKDOWN_HEADER}
                </Typography>
              </Box>
              {!isMulticity &&
                priceDropProtection &&
                isPDPEligible &&
                !isFareOptimizationCreditShopTime && (
                <PriceDropProtection
                  priceDropProtection={priceDropProtection}
                  onClick={() =>
                    trackEvent({
                      eventName: VIEWED_PRICE_DROP_DETAILS,
                      properties: {
                        page: "flight_book",
                      },
                    })
                  }
                />
              )}
              <Box className={clsx("payment-break-down")}>
                <PriceBreakdown isMobile={false} />
              </Box>
              {!isInPolicyCheckout && (
                <>
                  <ApprovalReasonTextarea
                    value={approvalRequestReason ?? ""}
                    className="approval-reason"
                    onChange={handleReasonChange}
                    corporateTravel={corporateTravel}
                    productType="flight"
                    tripType={tripCategory}
                    limit={policyLimit}
                  />
                  <ApprovalBanner
                    isApprovalRequired={
                      policies?.settings && policies.settings.isApprovalRequired
                    }
                  />
                </>
              )}
              <Box className="confirm-book-button-container">
                <Button
                  className="confirm-book-button"
                  disabled={
                    !isConfirmAndBookReady ||
                    (!isInPolicyCheckout && !approvalRequestReason)
                  }
                  onClick={onBookFlight}
                  data-testid="confirm-book-button"
                >
                  {BOOK_BUTTON_TEXT}
                </Button>
              </Box>
            </Box>
            {isVoidWindowExperiment && isVoidWindowEligible && (
              <VoidWindowNotice />
            )}

            {isCheckoutRewardsEarnBannerExperiment &&
              isCorpTenant(config.TENANT) &&
              accountForBanner?.productDisplayName?.includes(VXB) &&
              accountForBanner?.earn?.flightsMultiplier === 5 && (
                <Box
                  className={clsx("rewards-earn-banner-container")}
                  style={{ marginTop: "16px" }}
                >
                  <CorpRewardsEarnBanner
                    earn={calculatedEarn}
                    earnRewardsAccount={accountForBanner}
                    funnelType={FunnelType.FLIGHT}
                  />
                </Box>
              )}
          </Box>
        </Box>
      </Box>
      {openVIVariantModal && openVIVariantModal !== "reminder" && (
        <VirtualInterliningModal
          isMobile={false}
          variant={openVIVariantModal}
          fareDetails={tripDetails.fareDetails}
          airports={airports}
          isOpen
          onClose={() => setOpenVIVariantModal(false)}
        />
      )}
      {openMultipleAirlinesFares && (
        <MultipleAirlinesFareModal
          isOpen={openMultipleAirlinesFares}
          tripDetails={tripDetails}
          airports={airports}
          onClose={() => setOpenMultipleAirlinesFares(false)}
        />
      )}
    </Box>
  );
};
